// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnalyticsPage_page__UKVyY {
  position: relative;
  width: 100%;
  padding: 12px;
}

.AnalyticsPage_toolbar__9CkeP {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.AnalyticsPage_periodSelect__32Myf {
  width: 180px;
}

.AnalyticsPage_rangePicker__pv83S {
  width: 280px;
}

.AnalyticsPage_teamSelect__YLvCz {
  width: 220px;
}

.AnalyticsPage_toolbarCheckbox__OA\\+Lb {
  white-space: nowrap;
}

.AnalyticsPage_metricGrid__PtYUe {
  display: grid;
  grid-template-columns: repeat(4, minmax(170px, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.AnalyticsPage_metricCard__kyMk7 {
  border: 1px solid var(--cl-border);
  background: var(--cl-surface);
  border-radius: 8px;
  padding: 12px;
}

.AnalyticsPage_metricTitle__F4ddR {
  font-size: 12px;
  opacity: 0.75;
  margin-bottom: 6px;
}

.AnalyticsPage_metricLabel__FBkzE {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: normal;
}

.AnalyticsPage_infoMark__Fo67m {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  border: 1px solid var(--cl-border);
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  opacity: 0.75;
  cursor: help;
}

.AnalyticsPage_metricValue__xzkU- {
  font-size: 24px;
  font-weight: 700;
}

.AnalyticsPage_metricValueRow__hUzp5 {
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}

.AnalyticsPage_metricNote__JuCA1 {
  font-size: 13px;
  font-weight: 600;
  opacity: 0.72;
}

.AnalyticsPage_tableWrap__o0m5p {
  border: 1px solid var(--cl-border);
  border-radius: 8px;
  overflow: auto;
  background: var(--cl-surface);
}

.AnalyticsPage_section__QSLxu {
  margin-top: 18px;
}

.AnalyticsPage_sectionHeader__V7u9E {
  margin-bottom: 10px;
}

.AnalyticsPage_sectionTitle__jxE2x {
  margin: 0;
  font-size: 18px;
}

.AnalyticsPage_sectionHint__-AIGG {
  margin: 4px 0 0;
  font-size: 13px;
  opacity: 0.72;
}

.AnalyticsPage_kpiPanel__2np5T {
  margin-bottom: 10px;
  padding: 14px;
  border: 1px solid var(--cl-border);
  border-radius: 8px;
  background: var(--cl-surface);
}

.AnalyticsPage_kpiPanelHeader__fEDnM {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.AnalyticsPage_kpiPanelHeader__fEDnM h3 {
  margin: 0 0 4px;
  font-size: 16px;
}

.AnalyticsPage_kpiPanelHeader__fEDnM p {
  margin: 0;
  font-size: 13px;
  opacity: 0.76;
}

.AnalyticsPage_kpiPanelHeader__fEDnM > span {
  font-size: 12px;
  opacity: 0.7;
  white-space: nowrap;
}

.AnalyticsPage_kpiScales__fWmhv {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 12px;
}

.AnalyticsPage_kpiScale__Q-ERc {
  display: grid;
  gap: 7px;
}

.AnalyticsPage_kpiScale__Q-ERc > strong {
  font-size: 13px;
}

.AnalyticsPage_kpiScaleRows__88Ga3 {
  display: grid;
  grid-template-columns: repeat(5, minmax(100px, 1fr));
  gap: 4px;
}

.AnalyticsPage_kpiScaleRow__S5DuB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 38px;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 12px;
}

.AnalyticsPage_kpiScaleRow__S5DuB b {
  font-size: 13px;
}

.AnalyticsPage_coefficientBadge__vlfLk {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 42px;
  padding: 4px 9px;
  border-radius: 999px;
  font-weight: 700;
}

.AnalyticsPage_memberCell__2on07 {
  display: grid;
  gap: 5px;
  min-width: 150px;
}

.AnalyticsPage_kpiDetailsButton__BdWoV {
  width: fit-content;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--cl-primary, #1677ff);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}

.AnalyticsPage_kpiDetailsButton__BdWoV:hover {
  text-decoration: underline;
}

.AnalyticsPage_kpiDetailsRow__myDSU > td {
  padding: 0 !important;
  background: var(--cl-surface-2);
  white-space: normal !important;
}

.AnalyticsPage_kpiDetails__WviML {
  display: grid;
  grid-template-columns: repeat(2, minmax(420px, 1fr));
  gap: 12px;
  padding: 12px;
}

.AnalyticsPage_kpiDetailGroup__dSTIz {
  min-width: 0;
  padding: 10px;
  border: 1px solid var(--cl-border);
  border-radius: 7px;
  background: var(--cl-surface);
}

.AnalyticsPage_kpiDetailHeading__o1o3U {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
}

.AnalyticsPage_kpiDetailHeading__o1o3U span,
.AnalyticsPage_kpiDetailEmpty__J3Z3P {
  margin: 0;
  font-size: 12px;
  opacity: 0.72;
}

.AnalyticsPage_kpiDetailTableWrap__oekf1 {
  max-height: 320px;
  overflow: auto;
  border: 1px solid var(--cl-border);
  border-radius: 6px;
}

.AnalyticsPage_kpiDetailTable__dVjcv {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.AnalyticsPage_kpiDetailTable__dVjcv th,
.AnalyticsPage_kpiDetailTable__dVjcv td {
  padding: 7px 8px;
  border-bottom: 1px solid var(--cl-border);
  text-align: left;
  white-space: nowrap;
}

.AnalyticsPage_kpiSortButton__iLKdf {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
}

.AnalyticsPage_kpiSortArrow__Yqk1e {
  min-width: 12px;
  font-size: 12px;
  opacity: 0.7;
}

.AnalyticsPage_kpiDetailTable__dVjcv td:first-child {
  min-width: 240px;
  white-space: normal;
}

.AnalyticsPage_kpiExcellent__MR\\+7K {
  background: rgba(44, 196, 91, 0.22);
}

.AnalyticsPage_kpiGood__hU2yX {
  background: rgba(121, 196, 112, 0.22);
}

.AnalyticsPage_kpiNeutral__MWsnt {
  background: rgba(235, 202, 105, 0.26);
}

.AnalyticsPage_kpiWarning__O0dM9 {
  background: rgba(237, 162, 81, 0.25);
}

.AnalyticsPage_kpiLow__9KDHU {
  background: rgba(224, 91, 91, 0.22);
}

.AnalyticsPage_table__FOnpk {
  width: 100%;
  border-collapse: collapse;
  min-width: 1080px;
}

.AnalyticsPage_compactTable__j67C5 {
  width: 100%;
  border-collapse: collapse;
  min-width: 320px;
}

.AnalyticsPage_table__FOnpk th,
.AnalyticsPage_table__FOnpk td,
.AnalyticsPage_compactTable__j67C5 th,
.AnalyticsPage_compactTable__j67C5 td {
  padding: 10px;
  border-bottom: 1px solid var(--cl-border);
  text-align: left;
  white-space: nowrap;
}

.AnalyticsPage_table__FOnpk th,
.AnalyticsPage_compactTable__j67C5 th {
  font-weight: 700;
  background: var(--cl-surface-2);
}

.AnalyticsPage_slaGrid__eO6Je {
  display: grid;
  grid-template-columns: repeat(3, minmax(260px, 1fr));
  gap: 10px;
}

.AnalyticsPage_breakdownTable__P9Sav {
  min-width: 940px;
}

.AnalyticsPage_dailyTable__F4bMl {
  min-width: 1200px;
}

.AnalyticsPage_ratingGrid__cTLc2 {
  display: grid;
  grid-template-columns: minmax(260px, 360px) minmax(620px, 1fr);
  gap: 10px;
  align-items: start;
}

.AnalyticsPage_ratingCommentsTable__HLh2E {
  min-width: 980px;
}

.AnalyticsPage_ratingBadge__eSwoK {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 6px;
  background: var(--cl-surface-2);
  border: 1px solid var(--cl-border);
  font-weight: 700;
}

.AnalyticsPage_ticketCell__ZuE4E {
  display: grid;
  gap: 4px;
  min-width: 220px;
  max-width: 360px;
  white-space: normal;
}

.AnalyticsPage_commentCell__kPd6R {
  min-width: 280px;
  max-width: 520px;
  white-space: normal !important;
  line-height: 1.4;
}

.AnalyticsPage_summaryRow__EUQ0\\+ td {
  background: var(--cl-surface-2);
  font-weight: 600;
}

.AnalyticsPage_dailyCell__45Own {
  min-width: 92px;
  display: grid;
  gap: 4px;
  white-space: normal;
}

.AnalyticsPage_dailyMain__vmALm {
  font-size: 16px;
  font-weight: 700;
}

.AnalyticsPage_dailyHint__binPP {
  font-size: 12px;
  opacity: 0.75;
}

.AnalyticsPage_empty__GWt3J {
  text-align: center;
  opacity: 0.7;
}

.AnalyticsPage_activityCell__OYX9A {
  display: grid;
  gap: 4px;
  min-width: 280px;
  white-space: normal;
}

.AnalyticsPage_activityHint__MMR5b {
  font-size: 12px;
  opacity: 0.75;
}

.AnalyticsPage_taskLink__8A97A {
  color: var(--cl-primary, #1677ff);
  text-decoration: none;
}

.AnalyticsPage_taskLink__8A97A:hover {
  text-decoration: underline;
}

@media (max-width: 980px) {
  .AnalyticsPage_metricGrid__PtYUe {
    grid-template-columns: repeat(2, minmax(160px, 1fr));
  }
  .AnalyticsPage_kpiScales__fWmhv {
    grid-template-columns: 1fr;
  }
  .AnalyticsPage_kpiDetails__WviML {
    grid-template-columns: 1fr;
  }
  .AnalyticsPage_kpiScaleRows__88Ga3 {
    grid-template-columns: repeat(5, minmax(110px, 1fr));
    overflow-x: auto;
  }
}
@media (max-width: 620px) {
  .AnalyticsPage_page__UKVyY {
    padding: 8px;
  }
  .AnalyticsPage_toolbar__9CkeP {
    flex-direction: column;
    align-items: stretch;
  }
  .AnalyticsPage_periodSelect__32Myf {
    width: 100%;
  }
  .AnalyticsPage_rangePicker__pv83S {
    width: 100%;
  }
  .AnalyticsPage_teamSelect__YLvCz {
    width: 100%;
  }
  .AnalyticsPage_metricGrid__PtYUe {
    grid-template-columns: 1fr;
  }
  .AnalyticsPage_slaGrid__eO6Je {
    grid-template-columns: 1fr;
  }
  .AnalyticsPage_ratingGrid__cTLc2 {
    grid-template-columns: 1fr;
  }
  .AnalyticsPage_kpiPanelHeader__fEDnM {
    display: grid;
  }
  .AnalyticsPage_kpiPanelHeader__fEDnM > span {
    white-space: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Analytics/AnalyticsPage.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,kCAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kCAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,aAAA;AACF;;AAEA;EACE,kCAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,iCAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,qBAAA;EACA,+BAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;EACA,aAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,6BAAA;AACF;;AAEA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,SAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,cAAA;EACA,kCAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,mCAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;;;;EAIE,aAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,gBAAA;EACA,+BAAA;AACF;;AAEA;EACE,aAAA;EACA,oDAAA;EACA,SAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,8DAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,kCAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,8BAAA;EACA,gBAAA;AACF;;AAEA;EACE,+BAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,aAAA;AACF;;AAEA;EACE,iCAAA;EACA,qBAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE;IACE,oDAAA;EACF;EAEA;IACE,0BAAA;EAAF;EAGA;IACE,0BAAA;EADF;EAIA;IACE,oDAAA;IACA,gBAAA;EAFF;AACF;AAKA;EACE;IACE,YAAA;EAHF;EAMA;IACE,sBAAA;IACA,oBAAA;EAJF;EAOA;IACE,WAAA;EALF;EAQA;IACE,WAAA;EANF;EASA;IACE,WAAA;EAPF;EAUA;IACE,0BAAA;EARF;EAWA;IACE,0BAAA;EATF;EAYA;IACE,0BAAA;EAVF;EAaA;IACE,aAAA;EAXF;EAcA;IACE,mBAAA;EAZF;AACF","sourcesContent":[".page {\r\n  position: relative;\r\n  width: 100%;\n  padding: 12px;\n}\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n  flex-wrap: wrap;\n}\n\n.periodSelect {\n  width: 180px;\n}\n\n.rangePicker {\n  width: 280px;\n}\n\n.teamSelect {\n  width: 220px;\n}\n\n.toolbarCheckbox {\n  white-space: nowrap;\n}\n\n.metricGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(170px, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.metricCard {\n  border: 1px solid var(--cl-border);\n  background: var(--cl-surface);\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.metricTitle {\n  font-size: 12px;\n  opacity: 0.75;\n  margin-bottom: 6px;\n}\n\n.metricLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  white-space: normal;\n}\n\n.infoMark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  border: 1px solid var(--cl-border);\n  border-radius: 50%;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n  opacity: 0.75;\n  cursor: help;\n}\n\n.metricValue {\n  font-size: 24px;\n  font-weight: 700;\n}\n\n.metricValueRow {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.metricNote {\n  font-size: 13px;\n  font-weight: 600;\n  opacity: 0.72;\n}\n\n.tableWrap {\n  border: 1px solid var(--cl-border);\n  border-radius: 8px;\n  overflow: auto;\n  background: var(--cl-surface);\n}\n\n.section {\n  margin-top: 18px;\n}\n\n.sectionHeader {\n  margin-bottom: 10px;\n}\n\n.sectionTitle {\n  margin: 0;\n  font-size: 18px;\n}\n\n.sectionHint {\n  margin: 4px 0 0;\n  font-size: 13px;\n  opacity: 0.72;\n}\n\n.kpiPanel {\n  margin-bottom: 10px;\n  padding: 14px;\n  border: 1px solid var(--cl-border);\n  border-radius: 8px;\n  background: var(--cl-surface);\n}\n\n.kpiPanelHeader {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 12px;\n}\n\n.kpiPanelHeader h3 {\n  margin: 0 0 4px;\n  font-size: 16px;\n}\n\n.kpiPanelHeader p {\n  margin: 0;\n  font-size: 13px;\n  opacity: 0.76;\n}\n\n.kpiPanelHeader > span {\n  font-size: 12px;\n  opacity: 0.7;\n  white-space: nowrap;\n}\n\n.kpiScales {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(260px, 1fr));\n  gap: 12px;\n}\n\n.kpiScale {\n  display: grid;\n  gap: 7px;\n}\n\n.kpiScale > strong {\n  font-size: 13px;\n}\n\n.kpiScaleRows {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(100px, 1fr));\n  gap: 4px;\n}\n\n.kpiScaleRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  min-height: 38px;\n  padding: 6px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.kpiScaleRow b {\n  font-size: 13px;\n}\n\n.coefficientBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 42px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  font-weight: 700;\n}\n\n.memberCell {\n  display: grid;\n  gap: 5px;\n  min-width: 150px;\n}\n\n.kpiDetailsButton {\n  width: fit-content;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--cl-primary, #1677ff);\n  font: inherit;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.kpiDetailsButton:hover {\n  text-decoration: underline;\n}\n\n.kpiDetailsRow > td {\n  padding: 0 !important;\n  background: var(--cl-surface-2);\n  white-space: normal !important;\n}\n\n.kpiDetails {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(420px, 1fr));\n  gap: 12px;\n  padding: 12px;\n}\n\n.kpiDetailGroup {\n  min-width: 0;\n  padding: 10px;\n  border: 1px solid var(--cl-border);\n  border-radius: 7px;\n  background: var(--cl-surface);\n}\n\n.kpiDetailHeading {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.kpiDetailHeading span,\n.kpiDetailEmpty {\n  margin: 0;\n  font-size: 12px;\n  opacity: 0.72;\n}\n\n.kpiDetailTableWrap {\n  max-height: 320px;\n  overflow: auto;\n  border: 1px solid var(--cl-border);\n  border-radius: 6px;\n}\n\n.kpiDetailTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.kpiDetailTable th,\n.kpiDetailTable td {\n  padding: 7px 8px;\n  border-bottom: 1px solid var(--cl-border);\n  text-align: left;\n  white-space: nowrap;\n}\n\n.kpiSortButton {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  font-weight: 700;\n  text-align: left;\n  cursor: pointer;\n}\n\n.kpiSortArrow {\n  min-width: 12px;\n  font-size: 12px;\n  opacity: 0.7;\n}\n\n.kpiDetailTable td:first-child {\n  min-width: 240px;\n  white-space: normal;\n}\n\n.kpiExcellent {\n  background: rgba(44, 196, 91, 0.22);\n}\n\n.kpiGood {\n  background: rgba(121, 196, 112, 0.22);\n}\n\n.kpiNeutral {\n  background: rgba(235, 202, 105, 0.26);\n}\n\n.kpiWarning {\n  background: rgba(237, 162, 81, 0.25);\n}\n\n.kpiLow {\n  background: rgba(224, 91, 91, 0.22);\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 1080px;\n}\n\n.compactTable {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 320px;\n}\n\n.table th,\n.table td,\n.compactTable th,\n.compactTable td {\n  padding: 10px;\n  border-bottom: 1px solid var(--cl-border);\n  text-align: left;\n  white-space: nowrap;\n}\n\n.table th,\n.compactTable th {\n  font-weight: 700;\n  background: var(--cl-surface-2);\n}\n\n.slaGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(260px, 1fr));\n  gap: 10px;\n}\n\n.breakdownTable {\n  min-width: 940px;\n}\n\n.dailyTable {\n  min-width: 1200px;\n}\n\n.ratingGrid {\n  display: grid;\n  grid-template-columns: minmax(260px, 360px) minmax(620px, 1fr);\n  gap: 10px;\n  align-items: start;\n}\n\n.ratingCommentsTable {\n  min-width: 980px;\n}\n\n.ratingBadge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  height: 28px;\n  padding: 0 8px;\n  border-radius: 6px;\n  background: var(--cl-surface-2);\n  border: 1px solid var(--cl-border);\n  font-weight: 700;\n}\n\n.ticketCell {\n  display: grid;\n  gap: 4px;\n  min-width: 220px;\n  max-width: 360px;\n  white-space: normal;\n}\n\n.commentCell {\n  min-width: 280px;\n  max-width: 520px;\n  white-space: normal !important;\n  line-height: 1.4;\n}\n\n.summaryRow td {\n  background: var(--cl-surface-2);\n  font-weight: 600;\n}\n\n.dailyCell {\n  min-width: 92px;\n  display: grid;\n  gap: 4px;\n  white-space: normal;\n}\n\n.dailyMain {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.dailyHint {\n  font-size: 12px;\n  opacity: 0.75;\n}\n\n.empty {\n  text-align: center;\n  opacity: 0.7;\n}\n\n.activityCell {\n  display: grid;\n  gap: 4px;\n  min-width: 280px;\n  white-space: normal;\n}\n\n.activityHint {\n  font-size: 12px;\n  opacity: 0.75;\n}\n\n.taskLink {\n  color: var(--cl-primary, #1677ff);\n  text-decoration: none;\n}\n\n.taskLink:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 980px) {\n  .metricGrid {\n    grid-template-columns: repeat(2, minmax(160px, 1fr));\n  }\n\n  .kpiScales {\n    grid-template-columns: 1fr;\n  }\n\n  .kpiDetails {\n    grid-template-columns: 1fr;\n  }\n\n  .kpiScaleRows {\n    grid-template-columns: repeat(5, minmax(110px, 1fr));\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 620px) {\n  .page {\r\n    padding: 8px;\n  }\n\n  .toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .periodSelect {\n    width: 100%;\n  }\n\n  .rangePicker {\n    width: 100%;\n  }\n\n  .teamSelect {\n    width: 100%;\n  }\n\n  .metricGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .slaGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .ratingGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .kpiPanelHeader {\n    display: grid;\n  }\n\n  .kpiPanelHeader > span {\n    white-space: normal;\n  }\n}\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AnalyticsPage_page__UKVyY`,
	"toolbar": `AnalyticsPage_toolbar__9CkeP`,
	"periodSelect": `AnalyticsPage_periodSelect__32Myf`,
	"rangePicker": `AnalyticsPage_rangePicker__pv83S`,
	"teamSelect": `AnalyticsPage_teamSelect__YLvCz`,
	"toolbarCheckbox": `AnalyticsPage_toolbarCheckbox__OA+Lb`,
	"metricGrid": `AnalyticsPage_metricGrid__PtYUe`,
	"metricCard": `AnalyticsPage_metricCard__kyMk7`,
	"metricTitle": `AnalyticsPage_metricTitle__F4ddR`,
	"metricLabel": `AnalyticsPage_metricLabel__FBkzE`,
	"infoMark": `AnalyticsPage_infoMark__Fo67m`,
	"metricValue": `AnalyticsPage_metricValue__xzkU-`,
	"metricValueRow": `AnalyticsPage_metricValueRow__hUzp5`,
	"metricNote": `AnalyticsPage_metricNote__JuCA1`,
	"tableWrap": `AnalyticsPage_tableWrap__o0m5p`,
	"section": `AnalyticsPage_section__QSLxu`,
	"sectionHeader": `AnalyticsPage_sectionHeader__V7u9E`,
	"sectionTitle": `AnalyticsPage_sectionTitle__jxE2x`,
	"sectionHint": `AnalyticsPage_sectionHint__-AIGG`,
	"kpiPanel": `AnalyticsPage_kpiPanel__2np5T`,
	"kpiPanelHeader": `AnalyticsPage_kpiPanelHeader__fEDnM`,
	"kpiScales": `AnalyticsPage_kpiScales__fWmhv`,
	"kpiScale": `AnalyticsPage_kpiScale__Q-ERc`,
	"kpiScaleRows": `AnalyticsPage_kpiScaleRows__88Ga3`,
	"kpiScaleRow": `AnalyticsPage_kpiScaleRow__S5DuB`,
	"coefficientBadge": `AnalyticsPage_coefficientBadge__vlfLk`,
	"memberCell": `AnalyticsPage_memberCell__2on07`,
	"kpiDetailsButton": `AnalyticsPage_kpiDetailsButton__BdWoV`,
	"kpiDetailsRow": `AnalyticsPage_kpiDetailsRow__myDSU`,
	"kpiDetails": `AnalyticsPage_kpiDetails__WviML`,
	"kpiDetailGroup": `AnalyticsPage_kpiDetailGroup__dSTIz`,
	"kpiDetailHeading": `AnalyticsPage_kpiDetailHeading__o1o3U`,
	"kpiDetailEmpty": `AnalyticsPage_kpiDetailEmpty__J3Z3P`,
	"kpiDetailTableWrap": `AnalyticsPage_kpiDetailTableWrap__oekf1`,
	"kpiDetailTable": `AnalyticsPage_kpiDetailTable__dVjcv`,
	"kpiSortButton": `AnalyticsPage_kpiSortButton__iLKdf`,
	"kpiSortArrow": `AnalyticsPage_kpiSortArrow__Yqk1e`,
	"kpiExcellent": `AnalyticsPage_kpiExcellent__MR+7K`,
	"kpiGood": `AnalyticsPage_kpiGood__hU2yX`,
	"kpiNeutral": `AnalyticsPage_kpiNeutral__MWsnt`,
	"kpiWarning": `AnalyticsPage_kpiWarning__O0dM9`,
	"kpiLow": `AnalyticsPage_kpiLow__9KDHU`,
	"table": `AnalyticsPage_table__FOnpk`,
	"compactTable": `AnalyticsPage_compactTable__j67C5`,
	"slaGrid": `AnalyticsPage_slaGrid__eO6Je`,
	"breakdownTable": `AnalyticsPage_breakdownTable__P9Sav`,
	"dailyTable": `AnalyticsPage_dailyTable__F4bMl`,
	"ratingGrid": `AnalyticsPage_ratingGrid__cTLc2`,
	"ratingCommentsTable": `AnalyticsPage_ratingCommentsTable__HLh2E`,
	"ratingBadge": `AnalyticsPage_ratingBadge__eSwoK`,
	"ticketCell": `AnalyticsPage_ticketCell__ZuE4E`,
	"commentCell": `AnalyticsPage_commentCell__kPd6R`,
	"summaryRow": `AnalyticsPage_summaryRow__EUQ0+`,
	"dailyCell": `AnalyticsPage_dailyCell__45Own`,
	"dailyMain": `AnalyticsPage_dailyMain__vmALm`,
	"dailyHint": `AnalyticsPage_dailyHint__binPP`,
	"empty": `AnalyticsPage_empty__GWt3J`,
	"activityCell": `AnalyticsPage_activityCell__OYX9A`,
	"activityHint": `AnalyticsPage_activityHint__MMR5b`,
	"taskLink": `AnalyticsPage_taskLink__8A97A`
};
export default ___CSS_LOADER_EXPORT___;
